<pme-accordion-item (onToggle)="handleToggle($event)" *ngIf="onMobile; else noWrap">
    <img title src="/assets/images/icons-stepper/chevron_right.svg" [ngClass]="{open: accordionExpanded}" class="arrow">
    <ng-container title [ngTemplateOutlet]="ngContentTitle"></ng-container>
    <ng-container content [ngTemplateOutlet]="ngContentContent"></ng-container>
</pme-accordion-item>

<ng-template #noWrap>
    <ng-container *ngTemplateOutlet="ngContentTitle"></ng-container>
    <ng-container *ngTemplateOutlet="ngContentContent"></ng-container>
</ng-template>

<ng-template #ngContentTitle>
    <ng-content title select="[title]"></ng-content>
</ng-template>

<ng-template #ngContentContent>
    <ng-content select="[content]"></ng-content>
</ng-template>
